var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"list-toggle",class:{ 'list-toggle--active': _vm.isFollowed },on:{"click":_vm.onFollowToggle}},[_c('FontAwesomeIcon',{attrs:{"icon":"bookmark"}}),_c('span',{staticClass:"button-label"},[_vm._v(_vm._s(_vm.isFollowed ? _vm.$t('WEBAPP_UNFOLLOW') : _vm.$t('WEBAPP_FOLLOW')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }